import {gql} from "@irati/utils/gql"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

import fullPaymentOrder from "@irati/payments/services/fragments/fullPaymentOrder"

const query = gql`
  mutation CompleteTopup($topupId: ID!) {
    completeTopUp(topupId: $topupId) {
      uuid
      amount
      currency
      payment {
        status
        type
        paymentOrderUuid
        invoiceUuid
        poNumber
        invoiceNumber
      }
      metadata {
        createdAt
      }
      paymentOrder {
        ...fullPaymentOrder
      }
    }
  }
  ${fullPaymentOrder}
`

export const completeTopupKey = getQueryNames(query)[0]

export default query
